export const SEARCH_LOGINHISTORY = 'SEARCH_LOGINHISTORY'
export const SET_LOGINHISTORY_SEARCH_CRITERIA = 'SET_LOGINHISTORY_SEARCH_CRITERIA'
export const SET_LOGINHISTORY_DETAILS = 'SET_LOGINHISTORY_DETAILS'
export const SEARCH_TEMPLATEACCESS = 'SEARCH_TEMPLATEACCESS'
